export const SESSION_DISPLAY_FORMAT = "dd/MM/yyyy HH'h'mm";
